// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'
import { ICONVERSION as ICONVERSION_MERCEDES } from '../../../enums/Icons.mercedes'

@Component({
    name: 'GltState',
    mixins: [
        template,
    ]
})
export class GltState extends Vue {

    public get bgsrc() {
        return `${APP_ASSETS_URL}images/sprites/gltStateBuilding.svg#bg`
    }

    public get linesrc() {
        switch( this.state )
        {
            case 'not-arrived':
                return `${APP_ASSETS_URL}images/sprites/gltStateBuilding.svg#line1`;
            case 'arrived':
                return `${APP_ASSETS_URL}images/sprites/gltStateBuilding.svg#line2`;
            case 'completed':
                return `${APP_ASSETS_URL}images/sprites/gltStateBuilding.svg#line3`;
            case 'forwarded':
                return `${APP_ASSETS_URL}images/sprites/gltStateBuilding.svg#line4`;
        }
        return false
    }

    public get vehiclesrc() {
        return `${APP_ASSETS_URL}images/sprites/icons__mgs_${ICONVERSION_MERCEDES}.svg#${this.vehicletype}`
    }

    public get notNew()
    {
        return this.state != 'new'
    }

    public get showPrio()
    {
        return this.prioState && this.prioState != 'hidden'
    }

    @Prop({default:false})
    public disabled?: boolean

    @Prop({default: 'default'})
    public theme!: string

    @Prop({default: 'LKW'})
    public vehicletype!: string

    @Prop({default: 'new'})
    public state?: string

    @Prop()
    public stateName?:string

    @Prop()
    public qsState?:string

    @Prop({default:false})
    public showQs?:boolean

    @Prop()
    public prioState?:string

    @Prop()
    public prioStateName?:string
}